import CertificateWebPage from './CertificateWebPage';
export default CertificateWebPage;
